import { GraphQLQuery } from "@aws-amplify/api";
import { SearchQuizzesQuery } from "../../../API";
import { searchPublicQuizzes } from "../../../services/custom-queries";
import { generateClient } from "aws-amplify/api";

export default async function fetchPaginatedSearchPublicQuizzes(
  search?: string,
  nextToken?: string
) {
  try {
    const client = await generateClient();

    const quizData = await client.graphql<GraphQLQuery<SearchQuizzesQuery>>({
      query: searchPublicQuizzes,
      variables: { titleMatchPhrasePrefix: search, nextToken },
    });

    const list = quizData.data?.searchQuizzes;

    const quizIds = list?.items.map((quiz) => quiz?.id);
    // if quizIds is undefined or if any element of quizIds is undefined, throw an error
    if (!quizIds) {
      throw new Error("Quiz ids are undefined");
    }

    return { quizIds, nextToken: list?.nextToken };
  } catch (error) {
    console.error(error);
    return { quizIds: [], nextToken: "" };
  }
}
